import script from "./associate.vue?vue&type=script&setup=true&lang=js"
export * from "./associate.vue?vue&type=script&setup=true&lang=js"

import "./associate.vue?vue&type=style&index=0&id=40c693c9&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40c693c9"]])

export default __exports__